module.exports = __webpack_public_path__ + "static/img/illustration.b4069c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/illustration.png
// module id = M6Qn
// module chunks = 1